import {Component, input} from '@angular/core';
import {TableHeader} from '../../../shared/classes/TableHeader';
import {ContractHours} from '../../../classes/models/employee/ContractHours';
import {SHARED_IMPORTS} from '../../../shared/standalone-imports';

/**
 * This component displays contract working hours in a table.
 */
@Component({
  selector: 'app-contract-hours',
  templateUrl: './contract-hours.component.html',
  styleUrls: ['./contract-hours.component.less'],
  imports: [SHARED_IMPORTS]
})
export class ContractHoursComponent {

  /** A list of contract hours to be displayed as signal input. */
  contractHours = input<ContractHours[]>([]);

  /** Table headers of contract hours. */
  headers: TableHeader[] = [
    new TableHeader('Contract Hours', 'contractHours', false),
    new TableHeader('Start date', 'startDate', false)
  ];
}